(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oc-product-recommendation"] && !Shopify.designMode) return;
  try {
    
  const initSlider = (container) => {
    const splideElem = container.querySelector('.splide');
    if (splideElem && typeof Splide !== 'undefined') {
      new Splide(splideElem, {
        type: 'slide',
        perPage: 4,
        gap: '20px',
        breakpoints: {
          764: { perPage: 1, type: 'loop' }
        }
      }).mount();
    }
  };

  const loadRecommendations = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const section = entry.target;
        const { url, productId, limit, sectionId } = section.dataset;
        
        fetch(`${url}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector('.slider-product');
            
            if (newContent) {
              section.querySelector('.slider-product-container').innerHTML = newContent.outerHTML;
              initSlider(section);
            }
          })
          .catch(console.error);
        
        observer.unobserve(section);
      }
    });
  };

  const obs = new IntersectionObserver(loadRecommendations, { rootMargin: '200px' });
  
  document.querySelectorAll('.oc-recommend-slider').forEach(el => obs.observe(el));

  document.addEventListener('shopify:section:load', (e) => {
    const section = document.getElementById(`product-recommend-slider-${e.detail.sectionId}`);
    if (section) obs.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  function loadProductRecommendations() {
    const sprSection = document.querySelector('.product-recommendations');
    const { productId, limit, url } = sprSection.dataset;
    if (!sprSection) return;
    
    fetch(url + '?section_id=product-recommendations&product_id=' + productId + '&limit=' + limit)
      .then((response) => {
        if (!response.ok) { throw response };
        return response.text();
      })
      .then((html) => {
        const div = document.createElement('div');
        const colClass = new Map([['2', 'half'], ['3', 'third'], ['4', 'quarter'], ['5', 'fifth']]);

        div.innerHTML = html;
        div.querySelectorAll('.prod-block').forEach((el) => {
          el.classList.remove('half', 'third', 'quarter', 'fifth');
          el.classList.add(colClass.get(limit));
        });
        sprSection.parentElement.innerHTML = div.querySelector('.product-recommendations').innerHTML;

        window.theme.initAnimateOnScroll();
        window.dispatchEvent(new CustomEvent('checkcaptionheights'));

        // Shopify reviews app
        if (window.SPR && SPR.initDomEls && SPR.loadBadges) {
          SPR.initDomEls();
          SPR.loadBadges();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  document.addEventListener('shopify:section:load', (e) => {
    if (e.detail.sectionId === 'product-recommendations') {
      loadProductRecommendations();
    }
  });

  document.addEventListener('DOMContentLoaded', loadProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
